import { AnnouncementBar } from "theme";
class EbcAnnouncementBar extends AnnouncementBar {
  connectedCallback() {
    this._motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    this._announcementPaused = false;
    this._announcementHovered = false;
    this._announcementWrapper = this.closest(".announcement-bar__wrapper");
    super.connectedCallback();
    const signal = this._abortController.signal;
    const toggle = this._announcementWrapper?.querySelector("[data-announcement-toggle]");
    const sync = () => {
      const reduced = this._motionQuery.matches;
      const blocked = reduced || this._announcementPaused || this._announcementHovered || document.hidden || this._announcementWrapper?.contains(document.activeElement);
      if (blocked) this.player?.stop();
      else this.player?.start();
      this.setAttribute("aria-live", blocked ? "polite" : "off");
      if (toggle) {
        toggle.disabled = reduced;
        toggle.setAttribute("aria-label", reduced || this._announcementPaused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        toggle.querySelector("span").textContent = reduced || this._announcementPaused ? "▶" : "Ⅱ";
      }
    };
    toggle?.addEventListener("click", () => { this._announcementPaused = !this._announcementPaused; sync(); }, { signal });
    this._announcementWrapper?.addEventListener("mouseenter", () => { this._announcementHovered = true; sync(); }, { signal });
    this._announcementWrapper?.addEventListener("mouseleave", () => { this._announcementHovered = false; sync(); }, { signal });
    this._announcementWrapper?.addEventListener("focusin", sync, { signal });
    this._announcementWrapper?.addEventListener("focusout", () => queueMicrotask(sync), { signal });
    this._motionQuery.addEventListener("change", sync, { signal });
    document.addEventListener("visibilitychange", sync, { signal });
    sync();
  }
  async _transitionTo(fromSlide, toSlide) {
    if (!this._motionQuery.matches) {
      await fromSlide.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180 }).finished;
    }
    fromSlide.style.opacity = "0";
    fromSlide.style.visibility = "hidden";
    toSlide.style.visibility = "visible";
    toSlide.style.opacity = "1";
    if (!this._motionQuery.matches) {
      await toSlide.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 180 }).finished;
    }
  }
}
if (!customElements.get("ebc-announcement-bar")) customElements.define("ebc-announcement-bar", EbcAnnouncementBar);
